import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../SettingsPage/index.css';

const SupportPage = () => {
    const navigate = useNavigate();

    return (
        <div className="settings-page-wrapper">
            <div className="settings-header">
                <span className="settings-back-arrow" onClick={() => navigate(-1)}>‹</span>
                <h1 className="settings-title">Support</h1>
            </div>

            <div className="settings-container-card">
                <h2 className="text-content-title">Contact Support</h2>
                <div style={{ height: '20px' }}></div>

                {/* Email Card */}
                <div className="settings-item-card support-contact-card">
                    <div className="settings-item-left">
                        <span className="settings-icon material-icons" style={{ color: '#2196F3' }}>email</span>
                        <div className="support-info-text">
                            <span className="support-title">Email</span>
                            <span className="support-value">gullycinema@gmail.com</span>
                        </div>
                    </div>
                </div>

                <div style={{ height: '10px' }}></div>

                {/* Phone Card */}
                <div className="settings-item-card support-contact-card">
                    <div className="settings-item-left">
                        <span className="settings-icon material-icons" style={{ color: '#4CAF50' }}>phone</span>
                        <div className="support-info-text">
                            <span className="support-title">Phone Number</span>
                            <span className="support-value">9000022211</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportPage;
